import React from 'react';
import { clientMount } from '@vp/ubik-fragment-react';
import { Mount } from '@vp/ubik-fragment-types';
import { IdentityProvider } from '@vp/ubik-context';

import { getComponent } from '../ubik-entry/mapping';
import { createTrackingConfiguration } from './tracking-configuration';
import { createAuthConfig } from '../ubik-entry/auth';

// TODO: add support for types
const selectComponent = (props: any) => {
  const key = props.type;
  const trackingConfig = createTrackingConfiguration();

  const Component = getComponent(key);
  return () => (
    <IdentityProvider auth={createAuthConfig(props.locale)}>
      <Component {...(props as any)} trackingConfiguration={trackingConfig} />
    </IdentityProvider>
  );
};

export const mount: Mount<any> = async (rootElement, ssrProps) => {
  const Component = selectComponent(ssrProps);
  return clientMount(<Component />, { rootElement });
};
